import React from "react";
import { Link } from "react-router-dom";
import bg from "../../../../assets/img/landing-page/CTA_BG.png";
// import A1 from "../../../../assets/img/landing-page/A1.png";
// import A2 from "../../../../assets/img/landing-page/A2.png";
// import A3 from "../../../../assets/img/landing-page/A3.png";
// import icon1 from "../../../../assets/img/landing-page/Icon1.png";
// import icon2 from "../../../../assets/img/landing-page/Icon2.png";
// import icon3 from "../../../../assets/img/landing-page/Icon3.png";

import "./style.css";
const FreeService = () => {
  return (
    <div
      className="section ready-to-sell free-servise"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        position: "relative",
        paddingBottom: "80px",
        marginTop: "80px",
      }}
    >
      <div className="container">
        <div className="item" style={{ background: "none" }}>
          <div className="content-area text-center">
            <h2 style={{ color: "#fff" }}>
              Try Our Service Free! <br /> Get Started with 150 Free Credits
            </h2>

            <p style={{ color: "#fff" }}>
              Start your journey with us and see the power of our tools for
              yourself.
              <br />
              Sign up now and enjoy 150 free credits to boost your business
              growth
            </p>
            <div className="button-area">
              <Link to={"/"} className="btn btn-start free-service-btn">
                Start to Free
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeService;
